// :cow: Cosmose CONFIDENTIAL :iso:
import { InjectionToken } from '@angular/core';
import { EnvironmentConfig } from '@med/app/core/config/environment-config';

export const APP_CONFIG = new InjectionToken<EnvironmentConfig>('config');
